import React from 'react';
import { StyledCard } from './StyledBootstrap';
import { useTheme } from 'styled-components';
import logoBlack from '../../assets/icons/logo.svg';
import { Container, Row, Col } from 'react-bootstrap';

function EmailVerificationSent({children})
{
    const themeMode = useTheme();
    return (

        <Container fluid style={{ height: '100vh' ,backgroundColor: themeMode.background }} className='d-flex flex-column justify-content-center'>
            <Row className='justify-content-center'>
                <Col className='col-lg-4 col-md-6'>

                    <StyledCard>
                        <StyledCard.Body>
                        <Row className='justify-content-center mb-3'>
                                <Col md={10} className="text-center">
                                <img src={logoBlack} height="40rem"/>
                                </Col>
                            </Row>
                        <div className='text-center'>
                        {children}

                        </div>
            </StyledCard.Body>
                    </StyledCard>
                </Col>
            </Row>

        </Container>

    );
}

export default EmailVerificationSent;